import { useTranslation } from 'react-i18next';
import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import SystemNotifyContext from 'context/SystemNotifyContext';
import { listRoutes } from 'router/listRoutes';

export default function AreaLogada() {
	const navigate = useNavigate();
	const { t }: any = useTranslation();
	const { handleNotify } = useContext(SystemNotifyContext);

	useEffect(() => {
		navigate(listRoutes.users);
		handleNotify(t('greetings'), 'success', 3000);
	}, []);

	return null;
}
